
    import './src/benchmarks/browser.ts';

    const canvas = document.getElementById('canvas');
    const candidateCanvas = document.getElementById('candidateCanvas');
    const runBenchmarkBtn = document.getElementById('runBenchmark');
    const runAccuracyBtn = document.getElementById('runAccuracy');
    const copyResultsBtn = document.getElementById('copyResults');
    const progressContainer = document.getElementById('progressContainer');
    const progressFill = document.getElementById('progressFill');
    const progressText = document.getElementById('progressText');
    const resultsTable = document.getElementById('resultsTable');
    const jsonOutput = document.getElementById('jsonOutput');
    const accuracyResults = document.getElementById('accuracyResults');

    // Tab switching
    document.querySelectorAll('.tabs button').forEach(tab => {
      tab.addEventListener('click', () => {
        document.querySelectorAll('.tabs button').forEach(t => t.classList.remove('active'));
        document.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));
        tab.classList.add('active');
        document.getElementById(tab.dataset.tab + 'Tab').classList.add('active');
      });
    });

    // Resize canvas
    function resizeCanvas() {
      const rect = canvas.parentElement.getBoundingClientRect();
      canvas.style.width = (rect.width - 16) + 'px';
      if (candidateCanvas) candidateCanvas.style.width = canvas.style.width;
    }
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    let lastReport = null;

    function getConfig() {
      return {
        renderer: document.getElementById('rendererSelect').value,
        pointCounts: Array.from(document.getElementById('pointCountsSelect').selectedOptions).map(o => parseInt(o.value)),
        geometries: Array.from(document.getElementById('geometriesSelect').selectedOptions).map(o => o.value),
        warmupFrames: 5,
        measuredFrames: parseInt(document.getElementById('measuredFrames').value),
        hitTestSamples: parseInt(document.getElementById('hitTestSamples').value),
      };
    }

    runBenchmarkBtn.addEventListener('click', async () => {
      const config = getConfig();
      if (config.pointCounts.length === 0 || config.geometries.length === 0) {
        alert('Select at least one point count and geometry');
        return;
      }

      if (config.renderer === 'reference' && config.geometries.some((g) => g === 'euclidean3d' || g === 'sphere')) {
        alert('Reference renderer supports only euclidean and poincare. Use WebGL for 3D geometries.');
        return;
      }

      runBenchmarkBtn.disabled = runAccuracyBtn.disabled = true;
      progressContainer.classList.add('active');

      try {
        const report = await window.VizBenchmark.runBenchmarks(canvas, config, (msg, p) => {
          progressFill.value = p * 100;
          progressText.textContent = msg;
        });
        lastReport = report;
        resultsTable.innerHTML = window.VizBenchmark.formatResultsHTML(report);
        jsonOutput.textContent = JSON.stringify(report, null, 2);
        copyResultsBtn.disabled = false;
        console.log(window.VizBenchmark.formatResultsTable(report));
      } catch (err) {
        resultsTable.innerHTML = `<p class="placeholder" style="color:#ef4444">Benchmark failed: ${err.message}</p>`;
      } finally {
        runBenchmarkBtn.disabled = runAccuracyBtn.disabled = false;
        progressContainer.classList.remove('active');
      }
    });

    runAccuracyBtn.addEventListener('click', async () => {
      runBenchmarkBtn.disabled = runAccuracyBtn.disabled = true;
      progressContainer.classList.add('active');

      try {
        const reports = await window.VizBenchmark.runAccuracyBenchmarks(canvas, (msg, p) => {
          progressFill.value = p * 100;
          progressText.textContent = msg;
        });

        let html = '';
        for (const report of reports) {
          html += `<h2>${report.geometry.toUpperCase()}</h2>`;
          html += `<p style="margin-bottom:.5rem">Result: <strong style="color:${report.allPassed ? '#22c55e' : '#ef4444'}">${report.summary}</strong></p>`;
          for (const test of report.tests) {
            html += `<div class="test-result ${test.passed ? 'pass' : 'fail'}">`;
            html += `${test.passed ? '✓' : '✗'} ${test.operation}: maxError=${test.maxError.toExponential(2)}`;
            if (!test.passed && test.details) html += `<br><small>${test.details}</small>`;
            html += `</div>`;
          }
        }
        accuracyResults.innerHTML = html;

        // Switch to accuracy tab
        document.querySelectorAll('.tabs button').forEach(t => t.classList.remove('active'));
        document.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));
        document.querySelector('[data-tab="accuracy"]').classList.add('active');
        document.getElementById('accuracyTab').classList.add('active');
      } catch (err) {
        accuracyResults.innerHTML = `<p class="placeholder" style="color:#ef4444">Accuracy tests failed: ${err.message}</p>`;
      } finally {
        runBenchmarkBtn.disabled = runAccuracyBtn.disabled = false;
        progressContainer.classList.remove('active');
      }
    });

    copyResultsBtn.addEventListener('click', () => {
      if (lastReport) {
        navigator.clipboard.writeText(JSON.stringify(lastReport, null, 2));
        copyResultsBtn.textContent = 'Copied!';
        setTimeout(() => copyResultsBtn.textContent = 'Copy JSON', 2000);
      }
    });
  